import { Button, Card, Modal, Select, Table, TableColumns, TableColumnWidth, TableData, TablePreferences } from "@veneer/core";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate, useParams } from "react-router-dom";
import BackButton from "../../features/path/backButton";
import { IBrandDto } from "../../models/dto/agendaApi/IBrandDto";
import { ICompetitionDto } from "../../models/dto/agendaApi/ICompetitionDto";
import { CompetitionRegType } from "../../models/enum/CompetitionRegType";
import competitorsService from "../../services/agendaApi/competitors.service";
import '../../assets/css/views/activities/competitors.css';
import { BreadCrumbsEnum } from "../../models/enum/BreadCrumbsEnum";

export default function Competitors() {
    const [t] = useTranslation("global");
    const [loadingData, setLoadingData] = useState(true);
    const [brands, setBrands] = useState<TableData[]>([])
    const [dropdownValues, setDropdownValues] = useState([]);
    const params = useParams();
    const [appointmentActivityId, setAppointmentActivityId] = useState(0);
    const [appointmentId, setAppointmentId] = useState(0);
    const [competitionsArray, setCompetitionsArray] = useState<ICompetitionDto[]>([]);
    let competitions: ICompetitionDto[] = [];
    const navigate = useNavigate();
    const [openConfirmation, setOpenConfirmation] = useState(false);
    const [sendingData, setSendingData] = useState(false);

    useEffect(() => {
        setAppointmentActivityId(Number(params.id));
        setAppointmentId(Number(params.activityId));
        getDropDownValues();
    }, [])

    useEffect(() => {
        if (dropdownValues.length > 0)
            getBrands();
    }, [dropdownValues])

    const getDropDownValues = () => {
        competitorsService.getDropDownValues()
            .then(result => {
                setDropdownValues(result);
            })
            .catch(e => console.error(e));
    }

    const getBrands = () => {
        competitorsService.getBrands(false, appointmentId)
            .then((response: IBrandDto[]) => {
                fillData(response);
                setLoadingData(false);
            })
            .catch(e => console.error(e));
    }

    const onChange = (selectedOption: any, brandId: number, competitionRegType: number) => {
        const index = competitions.findIndex(c => c.brandId == brandId && c.competitionRegTypeId == competitionRegType);
        if (index === -1) {
            const competition: ICompetitionDto = { appointmentActivityId: appointmentActivityId, brandId: brandId, competitionRegTypeId: competitionRegType, quantity: selectedOption.value };
            competitions.push(competition);
        } else {
            competitions = competitions.map((item, i) => {
                if (i !== index) {
                    return item;
                }
                return { ...item, QUANTITY: selectedOption.value };
            })
        }
        setCompetitionsArray(competitions);
    }

    const sendData = () => {
        setSendingData(true);
        competitorsService.saveCompetitions(competitionsArray)
            .then(r => {
                setSendingData(false);
                setOpenConfirmation(true);
            })
            .catch(e => console.error(e));
    }

    const back = () => {
        setOpenConfirmation(false);
        navigate(-1);
    }

    const fillData = (data: IBrandDto[]) => {
        const pagedData: TableData[] = [];
        for (let i = 0; i < data.length; i++) {
            const brand: IBrandDto = data[i];
            let tableData: TableData = {};
            tableData = {
                'brand': <label>{brand.brandName}</label>,
                'advisor': <Select
                    clearIcon={false}
                    key={brand.brandID}
                    options={dropdownValues}
                    id="select-usage"
                    placement="top-start"
                    helperTextVisibility="auto"
                    onChange={(selectedOption) => onChange(selectedOption, brand.brandID, CompetitionRegType.advisor)}
                    value={brand.advisor}
                    className="selectCompetitors"
                />
                ,
                'activator': <Select
                    clearIcon={false}
                    key={brand.brandID}
                    options={dropdownValues}
                    id="select-usage"
                    placement="top-start"
                    helperTextVisibility="auto"
                    onChange={(selectedOption) => onChange(selectedOption, brand.brandID, CompetitionRegType.activator)}
                    value={brand.activator}
                    className="selectCompetitors"
                />,
                'merchant': <Select
                    clearIcon={false}
                    key={brand.brandID}
                    options={dropdownValues}
                    id="select-usage"
                    placement="top-start"
                    helperTextVisibility="auto"
                    onChange={(selectedOption) => onChange(selectedOption, brand.brandID, CompetitionRegType.merchant)}
                    value={brand.merchant}
                    className="selectCompetitors"
                />,
            }
            pagedData.push(tableData);
        }
        setBrands(pagedData);
    }

    const columns: TableColumns[] = [
        { id: 'brand', label: t("header.brand") },
        { id: 'advisor', label: t("header.advisor") },
        { id: 'activator', label: t("header.activator") },
        { id: 'merchant', label: t("header.merchant") }
    ];

    const columnsWidth: TableColumnWidth[] = [
        { columnId: 'brand', width: '25%', minWidth: '25%' },
        { columnId: 'advisor', width: '25%', minWidth: '25%' },
        { columnId: 'activator', width: '25%', minWidth: '25%' },
        { columnId: 'merchant', width: '25%', minWidth: '25%' }
    ]

    const tablePreferences: TablePreferences = {
        width: columnsWidth
    }

    return (
        <div>
            <div style={{ padding: '20px' }}>
                <BackButton route={BreadCrumbsEnum.ESFCoverage} activityId={appointmentId} appointmentActivityId={appointmentActivityId} />
                <h4>{t("header.competitionAdvisors")}</h4>
                {
                    brands.length > 0 && <div style={{ textAlign: "right", margin: '2%' }}>
                        <Button disabled={competitionsArray.length === 0} loading={sendingData} onClick={sendData}>
                            {t("modal.saveTitleInfo")}
                        </Button>
                    </div>
                }
                <Card appearance="outlined"
                    content={
                        <div style={{ padding: '20px' }}>
                            <Table
                                preferences={tablePreferences}
                                loading={loadingData}
                                columns={columns}
                                data={brands}
                                behavior={{
                                    type: 'singlePage',
                                }}
                                css={{
                                    height: '60vh',

                                }}
                                className="tableCompetitors"
                                columnResize={true}
                            />
                        </div>
                    }
                />

            </div>
            <Modal
                align="start"
                id="modal-id"
                show={openConfirmation}
                onClose={() => back()}
                footer={(
                    <div style={{ textAlign: 'center' }}>
                        <Button style={{ marginRight: 4 }} onClick={back}>{t('header.confirm')}</Button>
                    </div>
                )}
                title={t("header.information")}>
                <p>
                    {t("modal.saveSuccess")}
                </p>
            </Modal>
        </div>
    )
}